export class Audited {
    constructor(obj){
        if(!obj){
            return;
        }

        this.created = new Date(obj.created);
        this.creator = obj.creator;
        this.modified = new Date(obj.modified);
        this.modifier = obj.modifier;
    }
}